import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Type } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Footer } from '../components/Footer';
import { CompactHeader } from '../components/CompactHeader';

export default function OnlineSearch() {
  const [textSize, setTextSize] = useState('normal');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const adjustTextSize = (size) => {
    setTextSize(size);
  };

  const getFontSizeClass = () => {
    if (textSize === 'large') return 'text-lg';
    if (textSize === 'small') return 'text-sm';
    return 'text-base';
  };

  const handleSearch = () => {
    if (searchQuery.trim() !== "") {
      navigate(`/online-search/results?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader  />
      {/* Accessibility Controls Bar */}
      <div className="bg-[#1E293B] text-white py-3 px-4 sticky top-[100px] z-40">
        <div className="max-w-7xl mx-auto flex justify-end items-center">
          <div className="flex items-center gap-3">
            <Type className="w-5 h-5" aria-hidden="true" />
            <div className="flex gap-2" role="group" aria-label="Text size controls">
              {['small', 'normal', 'large'].map((size) => (
                <button
                  key={size}
                  onClick={() => adjustTextSize(size )}
                  className={`px-3 py-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 ${
                    textSize === size ? 'bg-white text-[#1E293B]' : 'bg-white/10 hover:bg-white/20'
                  }`}
                >
                  {size === 'small' ? 'A-' : size === 'normal' ? 'A' : 'A+'}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Online Case Search
            </h1>
            <p className={`${getFontSizeClass()} text-gray-800 max-w-3xl mx-auto drop-shadow-sm`}>
              Search by Suit Number or Party Name or Organisation Name or Case Filed Division.
            </p>
          </div>

          {/* Search Box */}
          <div className="max-w-2xl mx-auto">
            <div className="flex gap-3">
              <div className="flex-1">
                <Input
                  type="text"
                  placeholder="Enter Suit Number or Party Name or Organisation Name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className="w-full px-4 py-4 h-14 rounded-xl bg-white text-gray-900 border-0 focus:ring-2 focus:ring-[#155dfc]/50 placeholder:text-gray-500"
                />
              </div>
              <Button
                onClick={handleSearch}
                className="h-14 px-8 text-white rounded-xl focus:ring-2"
                aria-label="Search"
              >
                <Search className="mr-2 w-5 h-5" /> Search
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* BELOW THE <section> CLOSING TAG AND the tips section if you use it */}
<div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 dark:bg-slate-900">
    <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
        Frequently Asked Questions
    </h2>
    <div className="space-y-4">
        {/* Example FAQ Item */}
        <details className="p-4 rounded-lg bg-gray-100 dark:bg-gray-800 cursor-pointer">
            <summary className="font-medium text-gray-900 dark:text-gray-200">
                Are all historical cases available online?
            </summary>
            <p className={`${getFontSizeClass()} mt-2 text-gray-700 dark:text-gray-400`}>
                Currently, the database includes cases filed from October 2nd, 2013 onwards. Older records require a physical search request.
            </p>
        </details>
         <details className="p-4 rounded-lg bg-gray-100 dark:bg-gray-800 cursor-pointer">
            <summary className="font-medium text-gray-900 dark:text-gray-200">
                FAQ 2?
            </summary>
            <p className={`${getFontSizeClass()} mt-2 text-gray-700 dark:text-gray-400`}>
                Currently, the database includes cases filed from October 2nd, 2013 onwards. Older records require a physical search request.
            </p>
        </details>
         <details className="p-4 rounded-lg bg-gray-100 dark:bg-gray-800 cursor-pointer">
            <summary className="font-medium text-gray-900 dark:text-gray-200">
                FAQ 3?
            </summary>
            <p className={`${getFontSizeClass()} mt-2 text-gray-700 dark:text-gray-400`}>
                Currently, the database includes cases filed from October 2nd, 2013 onwards. Older records require a physical search request.
            </p>
        </details>
        {/* Add more <details> elements here */}
    </div>
</div>
 <Footer />
    </div>
  );
}
